export enum ReclaimCampaignMatchKind {
  LinkCode = "link_code",
  AttributionKind = "attribution_kind",
  UtmCampaign = "utm_campaign",
}
